import React from 'react';

export default function CertificateTypeDisplay(props)
{
    return (<span title={props.title} className={props.cssClass}>{props.label}</span>);
}